







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import AppRating from 'frontend/views/landing/AppRating.vue';
import TrustpilotRating from 'frontend/views/landing/TrustpilotRating.vue';
import PublishersList from 'frontend/views/landing/PublishersList.vue';
import { MobileGetter } from 'frontend/types';

interface Topic {
  name: string;
  url: string;
  image: string;
}

@Component({
  components: {
    PublishersList,
    AppRating,
    TrustpilotRating,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LandingHeroV2 extends Vue {
  @Prop({ type: String, required: true }) readonly videoUrl!: string;
  @Prop({ type: Object, required: true }) readonly ctaAxParams!: object;
  @Prop({ type: Boolean, default: true }) readonly showPublisherLogos!: boolean;
  @Prop({ type: Boolean, required: false }) readonly isMathcounts!: boolean;
  @Prop({ type: String, default: 'Get started' }) ctaButtonText!: string;
  @Prop({ type: Boolean, default: false }) private readonly isBelowFold!: boolean;

  private isMobile!: MobileGetter;

  private topics: Topic[] = [
    {
      name: 'Math',
      url: '/math/',
      image: '/site_media/version-1de7ac9e60/images/homepage/topic-math.png',
    },
    {
      name: 'Data Analysis',
      url: '/data-analysis/',
      image: '/site_media/version-32dd0ee41c/images/homepage/topic-data-analysis.png',
    },
    {
      name: 'Computer Science',
      url: '/cs/',
      image: '/site_media/version-0a482e698b/images/homepage/topic-computer-science.png',
    },
    {
      name: 'Programming',
      url: '/programming/',
      image: '/site_media/version-9cddcd3333/images/homepage/topic-programming.png',
    },
    {
      name: 'Science & Engineering',
      url: '/science/',
      image: '/site_media/version-affbf78367/images/homepage/topic-science-and-enginnering.png',
    },
  ];

  private get getStartedHref(): string {
    let route = 'nux_welcome';
    if (this.isMathcounts) {
      route = 'teacher_landing';
    }
    return this.$router.resolve({ name: route }).href;
  }

  private getStartedClickHandler(event: any): void {
    if (!this.isMathcounts) {
      event.preventDefault();
      this.$router.push({ name: 'nux_welcome' });
    }
  }
}
